class customError extends Error {
	constructor(message, code=0, data={}) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		super(message)
		this.name = this.constructor.name;

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, customError)
		}

		// Custom debugging information
		this.message = message
		this.code = code
		this.data = data
	}
}
export default customError;